import classNames from 'classnames';
import React, { useEffect, useRef, useCallback } from 'react';
import { getNid } from "../../wui-core/src/index";
import Icon from '../../wui-icon/src';
import { Color, MappingColor, NoticeProps } from './iNotification';
import { usePauseableTimer } from './utils';

function noop() {
}
const defaultProps = {
    onEnd: noop,
    onClose: noop,
    duration: 4.5,
    closable: true,
    color: "light"
}

const Notice: React.FC<NoticeProps> = (props) => {
    const {
        closable = defaultProps.closable,
        clsPrefix,
        className,
        style,
        children,
        color = defaultProps.color,
        title,
        message,
        fieldid,
        // eslint-disable-next-line no-unused-vars
        content,
        // eslint-disable-next-line no-unused-vars
        onEnd = defaultProps.onEnd,
        onClose = defaultProps.onClose,
        duration = defaultProps.duration,
        icon,
        closeIcon,
        btn,
        getPopupContainer,
        onClick,
        ...others
    } = props;

    const closeTimerRef = useRef<any>(null);

    useEffect(() => {
        if (duration) {
            closeTimerRef.current = usePauseableTimer({stopCb: onClose, duration: duration * 1000});
            closeTimerRef.current.start();
        }

        return () => {
            closeTimerRef.current?.clear();
        };
    }, [duration, onClose]);

    const close = useCallback(() => {
        if (!duration) { // 不自动关闭场景，要能close按钮关闭
            onClose?.();
        } else {
            closeTimerRef.current?.stop();
        }
    }, [duration, onClose]);

    const notifiClick = useCallback((e: React.MouseEvent) => {
        onClick?.(e);
    }, [onClick]);

    // 鼠标滑入暂停
    const pauseTimer = useCallback(() => {
        closeTimerRef.current?.pause();
    }, []);

    // 鼠标离开重启计时器
    const resumeTimer = useCallback(() => {
        closeTimerRef.current?.resume();
    }, []);

    const componentClass = `${clsPrefix}-notice`;
    const classes = {
        [`${componentClass}`]: 1,
        [`${componentClass}-closable`]: closable,
        [className ?? ""]: !!className,
    };
    let iconType = ({
        info: 'uf uf-i-c',
        success: 'uf uf-yiwancheng',
        danger: 'uf uf-exc-c',
        error: 'uf uf-exc-c',
        warning: 'uf uf-exc-t',
        light: 'uf',
        dark: 'uf',
        news: 'uf uf-bell',
        infolight: 'uf uf-i-c',
        successlight: 'uf uf-yiwancheng',
        dangerlight: 'uf uf-exc-c',
        warninglight: 'uf uf-exc-t',
    })[color as Color];
    // bip:强制转成light风格
    const mapping: MappingColor = {
        success: "successlight",
        info: "infolight",
        danger: "dangerlight",
        error: "dangerlight",
        warning: "warninglight",
    }
    let _color = '';
    if (color) {
        let tempColor = color in mapping ? mapping[color] : color;
        classes[`${componentClass}-${tempColor}`] = true;
        _color = color;
    }
    let adapterNid = getNid(props)
    return (
        <div className={classNames(classes)} style={style} onClick={notifiClick} onMouseEnter={pauseTimer} onMouseLeave={resumeTimer} {...others} {...adapterNid}>
            <div className={`${componentClass}-content`}>
                {(title || message) && (<div className={`${componentClass}-title`}>{icon ? icon : <i className={iconType}></i>}{title || message}</div>)}
                <div className={`${componentClass}-description`}>
                    {children}
                </div>
                {btn ?
                    <div className={`${componentClass}-btn`} onClick={close}>
                        {btn}
                    </div> : null}
            </div>
            {closable ?
                <a fieldid={fieldid && _color ? `${fieldid}_${_color}_close` : undefined} tabIndex={0} onClick={close} className={`${componentClass}-close`}>
                    <span className={`${componentClass}-close-x`}>{closeIcon ? closeIcon : <Icon type="uf-close"/>}</span>
                </a> : null
            }
        </div>
    );
};

export default Notice;
